<script setup lang="ts">
import {Venus, Mars} from "@lucide/vue";
import {computed} from "vue";

const props = defineProps<{
    /** The gender */
    gender: string
    /** The local value. */
    local: number
    /** The national value. */
    national: number
    /** whether to display as a currency. */
    currency?: boolean
}>();


const color = computed(() => {
    if (props.local >= props.national) {
        return "text-green-500";
    }

    return "text-red-500";
});

</script>

<template>
  <div class="flex items-center gap-1">
    <span :class="color">{{ currency ? local.toFixed(0) + " €" : local.toFixed(2) }}</span>
    <span class="text-xs"> / {{ currency ? national.toFixed(0) + " €" : national.toFixed(2) }}</span>
    <Mars v-if="gender === 'male'" class="text-blue" :size="10" />
    <Venus v-else class="text-pink-500" :size="10" />
  </div>
</template>
